const path = {
    local: 'http://localhost:8000/api/',
    prod: 'https://api.rapihire.com/api/',
    dev: 'https://apidev.rapihire.com/api/',
}

export const url = path.prod 
